import { jsx as _jsx } from "react/jsx-runtime";
import { checkStateToPill, cx } from '../internal/variants.js';
export function Pill({ state, tone, children }) {
    const spec = state ? checkStateToPill(state) : undefined;
    const resolvedTone = tone ?? spec?.tone ?? 'n';
    return _jsx("span", { className: cx('pill', resolvedTone), children: children ?? spec?.label ?? 'unverified' });
}
/** A pill with no leading dot — for neutral inline mono tags. */
export function PillPlain({ children, tone = 'n' }) {
    return _jsx("span", { className: cx('pill', 'plain', tone), children: children });
}
//# sourceMappingURL=Pill.js.map